// eslint-disable-next-line import/no-cycle
import {

    SETTING_CREATE_BED_CATEGORY,
    SETTING_CREATE_BED_CATEGORY_SUCCESS,
    SETTING_UPDATE_BED_CATEGORY,
    SETTING_UPDATE_BED_CATEGORY_SUCCESS,
    SETTING_LOAD_BED_CATEGORY,
    SETTING_LOAD_BED_CATEGORY_SUCCESS,
    SETTING_DELETE_BED_CATEGORY,
    SETTING_DELETE_BED_CATEGORY_SUCCESS,

    SETTING_LOAD_BED,
    SETTING_LOAD_BED_SUCCESS,
    SETTING_CREATE_BED,
    SETTING_CREATE_BED_SUCCESS,
    SETTING_UPDATE_BED,
    SETTING_UPDATE_BED_SUCCESS,
    SETTING_DELETE_BED,
    SETTING_DELETE_BED_SUCCESS,

    SETTING_CREATE_ROOM,
    SETTING_CREATE_ROOM_SUCCESS,
    SETTING_UPDATE_ROOM,
    SETTING_UPDATE_ROOM_SUCCESS,
    SETTING_LOAD_ROOM,
    SETTING_LOAD_ROOM_SUCCESS,
    SETTING_LOAD_ALL_BED_MAPPING,
    SETTING_LOAD_ALL_BED_MAPPING_SUCCESS,
    SETTING_DELETE_ROOM,
    SETTING_DELETE_ROOM_SUCCESS,

    SETTING_UPDATE_ROOM_STATUS,
    SETTING_UPDATE_ROOM_STATUS_SUCCESS,

} from '../../actions';

// // -------------------- getBedCategory --------------------- //
export const getBedCategory = (data, token) => ({
    type: SETTING_LOAD_BED_CATEGORY,
    payload: data,
    token
});
export const getBedCategorySuccess = (data, list) => ({
    type: SETTING_LOAD_BED_CATEGORY_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- addBedCategory --------------------- //
export const addBedCategory = (data, token) => ({
    type: SETTING_CREATE_BED_CATEGORY,
    payload: data,
    token
});
export const addBedCategorySuccess = () => ({
    type: SETTING_CREATE_BED_CATEGORY_SUCCESS,
});

// // -------------------- updateBedCategory --------------------- //
export const updateBedCategory = (data, token) => ({
    type: SETTING_UPDATE_BED_CATEGORY,
    payload: data,
    token
});
export const updateBedCategorySuccess = () => ({
    type: SETTING_UPDATE_BED_CATEGORY_SUCCESS,
});

// // -------------------- deleteBedCategory --------------------- //
export const deleteBedCategory = (data, token) => ({
    type: SETTING_DELETE_BED_CATEGORY,
    payload: data,
    token
});
export const deleteBedCategorySuccess = () => ({
    type: SETTING_DELETE_BED_CATEGORY_SUCCESS,
});

// // -------------------- getBed --------------------- //
export const getBed = (data, token) => ({
    type: SETTING_LOAD_BED,
    payload: data,
    token
});
export const getBedSuccess = (data, list) => ({
    type: SETTING_LOAD_BED_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- addBed --------------------- //
export const addBed = (data, token) => ({
    type: SETTING_CREATE_BED,
    payload: data,
    token
});
export const addBedSuccess = () => ({
    type: SETTING_CREATE_BED_SUCCESS,
});

// // -------------------- updateBed --------------------- //
export const updateBed = (data, token) => ({
    type: SETTING_UPDATE_BED,
    payload: data,
    token
});
export const updateBedSuccess = () => ({
    type: SETTING_UPDATE_BED_SUCCESS,
});

// // -------------------- deleteBed --------------------- //
export const deleteBed = (data, token) => ({
    type: SETTING_DELETE_BED,
    payload: data,
    token
});
export const deleteBedSuccess = () => ({
    type: SETTING_DELETE_BED_SUCCESS,
});

// // -------------------- updateRoom --------------------- //
export const updateChangeStatusRoom = (data, token) => ({
    type: SETTING_UPDATE_ROOM_STATUS,
    payload: data,
    token
});
export const updateChangeStatusRoomSuccess = () => ({
    type: SETTING_UPDATE_ROOM_STATUS_SUCCESS,
});

// // -------------------- getRoom --------------------- //
export const getRoom = (data, token) => ({
    type: SETTING_LOAD_ROOM,
    payload: data,
    token
});
export const getRoomSuccess = (data, list) => ({
    type: SETTING_LOAD_ROOM_SUCCESS,
    payload: data,
    payloadlist: list
});


// // -------------------- addRoom --------------------- //
export const addRoom = (data, token) => ({
    type: SETTING_CREATE_ROOM,
    payload: data,
    token
});
export const addRoomSuccess = () => ({
    type: SETTING_CREATE_ROOM_SUCCESS,
});

// // -------------------- updateRoom --------------------- //
export const updateRoom = (data, token) => ({
    type: SETTING_UPDATE_ROOM,
    payload: data,
    token
});
export const updateRoomSuccess = () => ({
    type: SETTING_UPDATE_ROOM_SUCCESS,
});

// // -------------------- deleteRoom--------------------- //
export const deleteRoom = (data, token) => ({
    type: SETTING_DELETE_ROOM,
    payload: data,
    token
});
export const deleteRoomSuccess = () => ({
    type: SETTING_DELETE_ROOM_SUCCESS,
});

// // -------------------- getAllBedMapping --------------------- //
export const getAllBedMapping = (data, token) => ({
    type: SETTING_LOAD_ALL_BED_MAPPING,
    payload: data,
    token
});
export const getAllBedMappingSuccess = (data, list) => ({
    type: SETTING_LOAD_ALL_BED_MAPPING_SUCCESS,
    payload: data,
    payloadlist: list
});
